module.exports = __webpack_public_path__ + "static/media/Facilities.97da9aea.jpg";